import { FormattedMessage, useIntl } from "react-intl";
import { Col } from "react-bootstrap";

import Dropdown from "components/atoms/Dropdown/Dropdown";
import { appendDefaultOption } from "helpers/commonHelpers";
import { dateRangeOptions } from "pages/common/Analytics/components/Reports/components/ReportForm/reportCustomOptions";

function DateFieldRange() {
  const intl = useIntl();
  return (
    <Col sm={4} md={4}>
      <FormattedMessage id="report.dateRange" defaultMessage="Date range" />
      <div className="mt-2">
        <Dropdown
          options={appendDefaultOption(dateRangeOptions(intl), intl)}
          defaultValue=""
          useHookForm
          name="date_range"
        />
      </div>
    </Col>
  );
}

export default DateFieldRange;
